<template>
    <div :class="['overlay', theme ? 'overlay_' + theme : '']" @keyup.esc="$emit('closeSearch')" @keydown="checkKeyEvent">
        <transition-group name="v-fade" appear tag="div" class="overlay-inner">
            <button @click="$emit('closeSearch')" key="closeButton" class="overlay-inner-close">
                <div class="visuallyHide_mobile vr_2">
                    Close
                </div>
                <i :class="['icon', 'icon_closingX', theme === 'light' ? 'icon_closingX_dark' : '']"></i>
            </button>
            <!-- TODO: dynamically supply action value for search field -->
            <div class="searchbar-wrapper"  key="searchScreenContent">
                <search-bar v-focus :center="true" :theme="theme"></search-bar>
            </div>
        </transition-group>
    </div>
</template>

<script>
import SearchBar from '../SearchBar/SearchBar.vue';
import FocusTrap from '../mixins/FocusTrap';

export default {
    props: ['theme'],
    mixins: [FocusTrap],
    components: {
        SearchBar
    },
}
</script>

<style lang="scss">
</style>